export function RadioDot({ selected }: { selected: boolean }) {
  return (
    <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-[#d4d4d8] bg-white">
      {selected && <span className="h-2 w-2 rounded-full bg-zinc-900" />}
    </span>
  );
}
